import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchSingleScanPage } from './report.endpoints';
import { TSingleScanPagePayload } from '../models/types';

export function useFetchSingleScanPage(payloadRef: Ref<TSingleScanPagePayload | null>) {
  const query = useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);
      return [
        'singleScanPage',
        payload?.jobId,
        payload?.folderName,
        payload?.page,
        payload?.limit,
        payload?.filters,
      ];
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) {
        return skipToken;
      }

      return () => fetchSingleScanPage(payload);
    }),
  });

  return query;
}
